import {defaultCountry, defaultLocaleId} from '@local/config/locales.mjs'
import {CurrencyCode, MoneyV2} from '@local/types/storefront-api-types'

export const formatPrice = (val, locale = defaultLocaleId, currency = defaultCountry?.currency.isoCode, options = {}) => {
	return new Intl.NumberFormat(locale, {
		currency,
		style: 'currency',
		unitDisplay: 'narrow',
		...options,
	}).format(val || 0)
}

export const formatMoney = (money: MoneyV2, locale = defaultLocaleId, defaultCurrencyCode: CurrencyCode = defaultCountry?.currency.isoCode as CurrencyCode) => {
	return formatPrice(money?.amount || 0, locale, money?.currencyCode || defaultCurrencyCode)
}
